<template>
    <v-container>
        <backupsList />
    </v-container>
</template>

<script>

import backupsList from "@/components/admin/backups/backupsList";
export default {
    name: 'Backups',
    components: { backupsList }
}
</script>

<style scoped>

</style>
